module.exports = __webpack_public_path__ + "img/10868_L.eed8c681.png";